/*
 * Auth
 * @module features/App
 * @flow
 */

export type AuthCallbackProps = $Shape<LoggedInUser> & {
  children?: React$Node,
  queryLogout?: boolean,
};

export const Auth = ({ id, queryLogout, children }: AuthCallbackProps) =>
  id && !queryLogout ? children : null;
